//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TopFilter from '@/components/buildings_top_filter'
import HouseItem from '@/components/business/house_item'
import WX_API from '@/utils/wx_api'
export default {
    components: {
        TopFilter,
        HouseItem
    },
    props: {
        name: {
            type: String
        },
        items: {
            type: Array
        },
        loading: {
            type: Boolean
        },
        no_more: {
            type: Boolean
        }
    },
    data () {
        return {
            filter_tabs: ['价格', '户型', '面积', '装修']
        }
    },
    methods: {
        toggleFilter () {
            this.backTop()
        },
        backTop (opt = { focus: false }) {
            WX_API.getElementPosition('#recommedation', this.$mp.component).then((res) => {
                if (!res) {
                    return
                }
                const { top, scrollTop } = res
                if (!opt.focus && top < 0) {
                    return
                }
                const building_scroll_top = top + scrollTop
                if (building_scroll_top) {
                    wx.pageScrollTo({
                        scrollTop: building_scroll_top
                    })
                }
            })
        },
        changeFilter (filter) {
            this.$emit('changeFilter', filter)
            this.backTop({ focus: true })
        }
    }
}
